import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';

export const BasketBarStyled = styled.div`
  padding: ${props => props.theme.padding};
  color: ${props => props.theme.secondaryColor};
  margin: 0 0 auto;
  background-color: ${props => props.theme.primaryBackground};
  border-right: ${p => p.theme.sideBasket.header.borderRight};
  ${media.small`
    margin: ${p => p.theme.sideBasket.margin};
    display: ${props => props.expand ? 'block' : 'none'};
    padding: ${props => props.expand ? props.theme.padding : 0};

    background-color: ${props => props.theme.sideBasket.backgroundColor};
    color: ${props => props.theme.primaryColor};
    width: 100%;
    border-right: 0;
    padding-bottom: ${p => p.expand ? '19rem' : 'initial'};
    margin-bottom: ${p => p.extraSpacing ? '2rem' : 'initial'};
  `};
`;



// WEBPACK FOOTER //
// ./components/BasketBar/BasketBar.style.js